import { BoxTemplateLabels, FileType, SubmissionEmailLabel } from 'enums';
import { PartialSubmission } from 'types';
import { getFileMetadataField, Nullable } from 'utils';
import useGetSubmissionRelatedEmails from 'broker/pages/SubmissionWorkspacePage/components/Toolbox/components/Email/useGetSubmissionRelatedEmails';
import { useFetchSubmissionFiles } from 'broker/pages/SubmissionWorkspacePage/hooks/useFetchSubmissionFiles';

export function useGetFilesAndEmails(partialSubmission: Nullable<PartialSubmission>) {
  const { items: submissionFiles, isLoading: submissionFilesLoading } = useFetchSubmissionFiles();

  const { submissionEmailsList, isLoading: submissionEmailsLoading } = useGetSubmissionRelatedEmails({
    submissionId: partialSubmission?.id,
  });

  const expiringPolicy = submissionFiles.find(
    (item) => getFileMetadataField(item, BoxTemplateLabels.FileType) === FileType.ExpiringProgram,
  );

  const renewalPolicy = submissionFiles.find(
    (item) => getFileMetadataField(item, BoxTemplateLabels.FileType) === FileType.RenewalPolicy,
  );

  const application = submissionFiles.find(
    (item) => getFileMetadataField(item, BoxTemplateLabels.FileType) === FileType.Submission,
  );

  const proposalFile = submissionFiles.find(
    (item) => getFileMetadataField(item, BoxTemplateLabels.FileType) === FileType.Proposal,
  );

  const solicitationEmail = submissionEmailsList.find((email) => !!email.labels?.informationRequestData?.value);

  const marketingEmails = submissionEmailsList.filter(
    (email) => email.label === SubmissionEmailLabel.SubmissionMarketing,
  );

  const proposalEmail = submissionEmailsList.find((email) => email.label === SubmissionEmailLabel.Proposal);

  const quoteComparison = submissionFiles.find(
    (item) => getFileMetadataField(item, BoxTemplateLabels.FileType) === FileType.QuoteComparison,
  );

  const marketQuotes = submissionFiles.filter(
    (item) => getFileMetadataField(item, BoxTemplateLabels.FileType) === FileType.MarketQuote,
  );

  return {
    application,
    expiringPolicy,
    renewalPolicy,
    proposalFile,
    solicitationEmail,
    marketingEmails,
    marketQuotes,
    quoteComparison,
    proposalEmail,
    isLoading: submissionFilesLoading || submissionEmailsLoading,
  };
}
